// Builds a `mailto:` URL that opens the admin's default email
// application with a pre-populated draft for the "Share with
// prospect" flow. Extracted so it can be unit-tested without
// dragging the Territory Builder page into the Jest transform.
//
// Every dynamic value flows through ``encodeURIComponent`` — that
// covers Unicode names, spaces, ampersands in the URL query, and
// the CRLF line breaks required for the body. RFC 6068 wants
// individual header values percent-encoded and reserves `+` as a
// literal (it does NOT decode to space, unlike form URL encoding),
// so we deliberately avoid ``URLSearchParams`` here.

export const PROSPECT_EMAIL_SUBJECT = "Your potential Creative Mojo franchise territory";

export const NO_EMAIL_MESSAGE = "The share link has been created, but this contact does not have an email address.";

export function buildProspectEmailBody({ firstName, homeCount, shareUrl }) {
  const name = (firstName || "").trim() || "there";
  const count = Number.isFinite(homeCount) && homeCount > 0 ? homeCount : 0;
  // Sam's brief specifies "up to {n} care homes" — keep verbatim.
  return (
    `Hi ${name},\r\n` +
    `\r\n` +
    `Here is a link to view your potential Creative Mojo franchise territory:\r\n` +
    `\r\n` +
    `${shareUrl}\r\n` +
    `\r\n` +
    `This proposed territory includes up to ${count} care homes. ` +
    `The coloured outlines outside the proposed territory indicate ` +
    `the locations of nearby existing Creative Mojo franchises.\r\n` +
    `\r\n` +
    `At this stage, we can adjust the territory where availability ` +
    `allows. If the proposed area isn't quite right for you, or you ` +
    `would prefer any changes to be made, please let us know.`
  );
}

export function buildProspectMailto({ email, firstName, homeCount, shareUrl }) {
  const to = encodeURIComponent((email || "").trim());
  const subject = encodeURIComponent(PROSPECT_EMAIL_SUBJECT);
  const body = encodeURIComponent(buildProspectEmailBody({ firstName, homeCount, shareUrl }));
  return `mailto:${to}?subject=${subject}&body=${body}`;
}
